<template>
    <div id="page">
        <div class="page-content">
            <div class="fixed-top-box">
                <div class="page-title page-title-small">
                    <h2 class="page-title-h2">
                        <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                        فعالیت های روزانه
                        <!--<button data-menu="HelpMenu" class="position-static"><i class="fa fa-question-circle helpIco"></i></button>-->
                    </h2>
                    <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                    <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
                </div>
                <div class="card header-card shape-rounded" data-card-height="100">
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                </div>
                <div class="card card-style mb-2">
                    <div class="p-3 d-flex">
                        <button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
                            <i class="fa fa-filter text-white"></i>
                        </button>
                        <div class="filter-row-scrollable">
                            <div @click="lstFilter('MyOtherWork',0)" id="MyOtherWork" class="filterSelectItem filter-scrollable-box selected">فعالیت های من</div>
                            <div @click="lstFilter('MyTramOtherWork',1)" id="MyTramOtherWork" class="filterSelectItem filter-scrollable-box">فعالیت های تیم من</div>
                        </div>
                    </div>
                </div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>
            <div v-if="true" class="main-content-box">

                <!--<calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>-->

                <div class="card card-style mb-2" v-for="task in OtherWorkList" :key="task.otherWorkId">

                    <div class="py-2 pl-2 pr-3" :id="'otherWork-'+task.otherWorkId">
                        <button data-toggle="collapse" type="button" :data-target="'#collapse-'+task.otherWorkId" class="no-effect collapsed accordion-btn pr-0" aria-expanded="false">
                            <span class="d-flex justify-content-between align-items-center">
                                <span class="w-100 d-flex flex-column">
                                    <b class="font-13 text-dark">{{task.subject}}</b>
                                    <span class="d-flex w-100 justify-content-between">
                                        <span class="text-muted">{{task.workDate}}</span>
                                        <span v-if="task.workUsedTime!==''" class="d-flex align-items-center text-muted ml-3">
                                            زمان صرف شده: {{task.workUsedTime}}
                                        </span>

                                    </span>
                                </span>
                                <i class="fa fa-angle-up text-muted font-18 accordion-icon fa-rotate-180"></i>
                            </span>
                        </button>
                    </div>

                    <div class="collapse border-t" :id="'collapse-'+task.otherWorkId" @click.prevent="openDetails(task.otherWorkId)">

                        <div class="d-flex justify-content-between p-2">
                            <div class="d-flex justify-content-between">
                                <div class="d-inline-flex align-items-center">
                                    <!--اگر کاربر تصویر پروفایل نداشت-->
                                    <!--<i class="fa fa-user color-green2-light ml-3"></i>-->
                                    <!---->
                                    <!--تصویر کاربر ثبت کننده فعالیت-->
                                    <img v-if="task.userImg!=null && task.userImg!=''" :src="task.userImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />
                                    <i v-else class="fa fa-user-circle color-green2-light ml-2 font-30"></i>
                                    <span>{{task.userTitle}}</span>
                                </div>
                               
                                <!--<div>
                                    <i class="fa fa-hashtag color-blue2-dark ml-3"></i>
                                    <span class="text-muted">{{task.workNo}}</span>
                                </div>-->
                            </div>
                            <span class="text-left" @click.stop="showMenu(task)">
                                <span>
                                    <span class="badge font-10 position-static ml-2 mt-0" :class="getClassNameForOtherWorkPreferenceType(task.preferenceTypeId)">{{task.preferenceTypeTitle}}</span>
                                </span>
                                <span class="px-2">
                                    <i class="fa fa-ellipsis-v font-14"></i>
                                </span>
                                
                            </span>
                        </div>

                    </div>
                </div>


                <!--<div class="card card-style" v-if="Loading">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>
                </div>-->

                <div class="card card-style" v-if="Loading==false && NoMoreData==false && OtherWorkList.length>0 && OtherWorkList.length%10==0">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100">
                            <button class="btn btn-outline-info rounded-m" @click="getNextPageForOtherWorkList">نمایش بیشتر</button>
                        </div>
                    </div>
                </div>
                <div class="card card-style" v-if="Loading==false && OtherWorkList.length==0">
                    <div class="content">
                        <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                        <p class="text-center py-3">فعالیتی یافت نشد.</p>
                    </div>
                </div>
            </div>


            <div class="card card-style" v-else>
                <div class="content">
                    <h4 class="mb-0 text-center">تصاویر بخش فعالیت ها</h4>
                </div>
                <div class="divider mb-0"></div>
                <div class="gallery-view-controls d-flex justify-content-center">
                    <a href="#" class="gallery-view-1-activate"><i class="fa fa-th"></i></a>
                    <a href="#" class="gallery-view-2-activate color-highlight"><i class="fa fa-th-large"></i></a>
                    <div class="clearfix"></div>
                </div>
                <div class="content my-n1">
                    <div class="gallery-views gallery-view-2">
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/otherWorkList-1-L.jpg" title="لیست فعالیت های من" class="default-link">
                            <img src="/assets/images/gallery/otherWorkList-1-500x500.jpg" data-src="/assets/images/gallery/otherWorkList-1-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">لیست فعالیت های من</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/otherWorkList-2-L.jpg" title="لیست فعالیت های تیم من" class="default-link">
                            <img src="/assets/images/gallery/otherWorkList-2-500x500.jpg" data-src="/assets/images/gallery/otherWorkList-2-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">لیست فعالیت های تیم من</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/otherWorkList-3-L.jpg" title="ثبت فعالیت های روزانه" class="default-link">
                            <img src="/assets/images/gallery/otherWorkList-3-500x500.jpg" data-src="/assets/images/gallery/otherWorkList-3-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">ثبت فعالیت های روزانه</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/otherWorkList-4-L.jpg" title="انتخاب نوع فعالیت" class="default-link">
                            <img src="/assets/images/gallery/otherWorkList-4-500x500.jpg" data-src="/assets/images/gallery/otherWorkList-4-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">انتخاب نوع فعالیت</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/otherWorkList-5-L.jpg" title="ضمیمه کردن فایل به فعالیت" class="default-link">
                            <img src="/assets/images/gallery/otherWorkList-5-500x500.jpg" data-src="/assets/images/gallery/otherWorkList-5-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class="color-theme">ضمیمه کردن فایل به فعالیت</h4>
                                <div class="divider bottom-0"></div>
                            </div>
                        </a>
                        <a data-lightbox="gallery-1" href="/assets/images/gallery/otherWorkList-6-L.jpg" title="ضبط مستقیم فایل صوتی" class="default-link">
                            <img src="/assets/images/gallery/otherWorkList-6-500x500.jpg" data-src="/assets/images/gallery/otherWorkList-6-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
                            <div class="caption">
                                <h4 class=" color-theme">ضبط مستقیم فایل صوتی</h4>
                            </div>
                        </a>
                    </div>
                </div>

                <a href="/order" class="btn btn-l btn-icon bg-green2-dark rounded-s shadow-s btn-full btn-margins font-900 text-uppercase text-left mt-3"><i class="fa fa-credit-card text-center"></i>خرید اشتراک اپلیکیشن</a>
            </div>

        </div>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-if="pageLoaded==true && isFreeRegist!==true" class="addBtn" id="addBtn" ref="addBtn">
                <router-link to="/CreateOtherWork">
                    <div class="icon icon-m rounded-m color-white bg-green2-light">
                        <i class="fa fa-plus"></i>
                    </div>
                </router-link>
            </div>
        </transition>

        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'EditOtherWork', params: { otherWorkId: selectedWorkId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
                    <router-link :to="{ name: 'CreateOtherWork', params: { parentId: selectedWorkId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>افزودن فعالیت زیر مجموعه</span><i class="fa fa-angle-left"></i></router-link>
                    <button @click="AddPin" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-thumbtack color-blue2-light float-right font-14"></i>نشان کردن</span><i class="fa fa-angle-left"></i></button>

                    <button @click="deleteOtherWork" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>

                </div>
                <div class="clear"></div>
            </div>
        </div>
        <div id="searchModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header align-items-center">
                        <h4 class="modal-title mt-0">جستجو</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body m-0">
                        <!--<div class="mb-3">
                            <v-select dir="rtl" label="title" placeholder="کاربر" :filterable="localUserListList.length>10" :searchable="localUserListList.length>10" :options="localUserListList" :reduce="p => p.userId" v-model="userId">
                                <template slot="option">
                                    <div class="d-center">
                                        {{ option.title }}
                                    </div>
                                </template>
                            </v-select>
                        </div>-->

                        <div class="w-100 search-box rounded-m position-relative mb-3">
                            <i class="fa fa-search pr-3"></i>
                            <input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey">
                        </div>

                        <myTeamList txtPlaceholder="کاربران" class="mb-3" @selectUser="selectUser"></myTeamList>
                        <projects class="mb-3" @selectProject="selectProject"></projects>
                        <preferenceTypeList txtPlaceholder="ضرورت" class="mb-3" @selectPreferenceType="selectPreferenceType"></preferenceTypeList>
                        <calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>


                        <button type="button" class="btn btn-xxs mt-3 btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="filterList">
                            <i class="fa fa-search ml-2"></i>
                            جستجو
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <Help-Menu title="راهنمای ثبت فعالیت" keyEn="OtherWorkList"></Help-Menu>
        
        <my-tour></my-tour>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>

    </div>



</template>

<script>
    import myTour from '../Tours/OtherWorkListTour.vue'
    import VueSimpleAlert from "vue3-simple-alert";
    import calendarFilter from '../Components/CalendarFilter.vue';
    import ProjectList from '../Components/ProjectList.vue';
    import MyTeamList from '../Components/MyTeamList.vue';
    import HelpMenu from '../Components/HelpMenu.vue';
    import PreferenceType from '../Components/PreferenceTypeList.vue';
    export default {
        components: {
            myTour,
            "Help-Menu": HelpMenu,
            "preferenceTypeList": PreferenceType,
            "calendar-filter": calendarFilter,
            "projects": ProjectList,
            "myTeamList": MyTeamList,
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey: "",
                selectedWorkId: 0,
                preferenceTypeId: null,
                selectedTitle: null,
                pageLoaded: false,
                date: null,
                userId: null,
                projectId: null,

            };
        },
        computed: {
            OtherWorkList() {
                return this.$store.getters.GetOtherWorkList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            NoMoreData() {
                return this.$store.getters.GetOtherWorkNoMoreData;
            },
            isFreeRegist() {
                return this.$store.getters.GetIsFreeRegist;
            },
            UpdateOtherWorkList() {
                return this.$store.getters.GetUpdateOtherWorkList;
            },
            localUserListList() {
                return this.$store.getters.GetLocalUserListList;
            },
        },

        created() {
            /*this.getUserList();*/
/*            this.filterList();*/
        },
        methods: {
            selectPreferenceType(d) {
                this.preferenceTypeId = d;
            },
            getUserList() {
                this.$store.dispatch("GetLocalUserListListFromServer", {
                    workGroupId: null
                });
            },
            lstFilter(filterSelect, filterId) {
                this.filterId = filterId;
                var elements = document.getElementsByClassName('filterSelectItem');
                for (var i = 0; i < elements.length; i++) {
                    elements[i].classList.remove('selected');
                }
                document.getElementById(filterSelect).classList.add('selected');
                this.filterList();
            },
            showAddButton() {
                this.pageLoaded = true;
            },
            showMenu(item) {
                this.selectedWorkId = item.otherWorkId;
                this.selectedTitle = item.subject;
                document.getElementsByClassName("optionMenu")[0].click();

            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetOtherWorkListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey,
                    date: this.date,
                    projectId: this.projectId,
                    preferenceTypeId: this.preferenceTypeId,
                    userId: this.userId
                });
            },
            deleteOtherWork() {
                document.getElementsByClassName('menu-hider')[0].click();
                VueSimpleAlert.confirm("آیا مایل به حذف این فعالیت هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("OtherWork/Delete?id=" + this.selectedWorkId)
                        .then(data => {
                            var res = data.data;
                            if (res.includes("حذف شد")) {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.filterList();

                            }
                            else {
                                this.showErrorMessage(res);
                            }
                        });
                });
            },
            selectDate(d) {
                this.date = d;
                this.page = 0;
            },
            selectProject(d) {
                this.projectId = d;
            },
            selectUser(d) {
                this.userId = d;
            },
            openDetails(otherWorkId) {
                this.$router.push({ name: 'EditOtherWork', params: { otherWorkId: otherWorkId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            getNextPageForOtherWorkList() {
                this.page++;
                this.$store.dispatch("GetOtherWorkListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey,
                    preferenceTypeId: this.preferenceTypeId,
                    projectId: this.projectId,
                    date: this.date,
                    userId: this.userId
                });
            },
            AddPin() {
                document.getElementsByClassName("menu-hider")[0].click();
                VueSimpleAlert.confirm(
                    "آیا مایل به نشان کردن این مورد هستید؟",
                    null,
                    "question",
                    { confirmButtonText: "تایید", cancelButtonText: "انصراف" }
                ).then(() => {

                    this.$store.dispatch("AddPin", {
                        baseDocId: 16,
                        docId: this.selectedWorkId,
                        description: this.selectedTitle
                    });
                });

            },
            pauseVid(id) {
                if (id != null) {
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
            getClassNameForOtherWorkPreferenceType(typeId) {
                var classNsme = "";
                typeId = parseInt(typeId);

                switch (typeId) {
                    case 2:
                        classNsme = "badge-primary";
                        break;
                    case 1:
                        classNsme = "badge-danger";
                        break;
                    case 4:
                        classNsme = "badge-warning text-white";
                        break;
                    case 3:
                        classNsme = "badge-success";
                        break;
                    default:
                        classNsme = "badge-info";
                        break;
                }
                return classNsme;
            },
        },
        activated() {
            this.showAddButton();
            if (this.UpdateOtherWorkList == true) {
                this.page = 0;
                this.getNextPageForOtherWorkList();
            }
        },
        mounted() {
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        }
    };
</script>
